import { queryClient } from '@/queryClient';

// type OldData = {
// 	payload?: {
// 		user?: object;
// 	};
// };

export const readCache = <T, TData>(key: T): TData | undefined => {
	const keyData = Array.isArray(key) ? key : [key];
	return queryClient.getQueryData(keyData);
};

export const updateCache = <T, TData>(
	key: T,
	field: null | string | number | undefined,
	value: TData
): void => {
	// Use when update single data in cache
	const keyData = Array.isArray(key) ? key : [key];
	queryClient.setQueriesData(
		{
			queryKey: keyData,
		},
		(oldData: { status: string; payload: object }) => {
			if (!field) {
				return value;
			} else {
				return {
					...oldData,
					payload: {
						...oldData?.payload,
						[field]: value,
					},
				};
			}
		}
	);
};

// export const updateUserCache = <TData>(
// 	field: string | null = null,
// 	value: TData
// ): void => {
// 	queryClient.setQueriesData<string, object>(
// 		['get', '/api/user/get', {}],
// 		(oldData: object) => {
// 			if (!field) {
// 				return value;
// 			} else {
// 				return {
// 					...(oldData as OldData),
// 					payload: {
// 						...(oldData as OldData)?.payload,
// 						user: {
// 							...(oldData as OldData)?.payload?.user,
// 							[field]: value,
// 						},
// 					},
// 				};
// 			}
// 		}
// 	);
// };
